// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"088ce796","306":"3093d312","364":"920f1e47","366":"7c6e2b07","635":"8ef67b76","683":"5b48caa8","730":"37309a47","736":"36249500","785":"9a3a56dc","825":"bf4265f4","949":"f4db75ba"}[chunkId] + ".chunk.js";
};